import { trimForm } from '@/utils'
import i18n from '@/plugins/vue-i18n'
import { ENV_KEY } from '@/constants/env'

export default {
  methods: {
    getTokenCard({ holdername, cardno, expire, securitycode, tokennumber = 1 }) {
      // eslint-disable-next-line no-undef
      Multipayment.init(this.$store.getters['env/GET_KEY'](ENV_KEY.GMO_ID))

      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Multipayment.getToken(
          trimForm({
            holdername,
            cardno,
            expire,
            securitycode,
            tokennumber,
          }),
          (res) => {
            if (res.resultCode !== '000') {
              reject({
                response: {
                  data: {
                    meta: {
                      message: i18n.t('common.messages.cardInvalid'),
                    },
                  },
                },
              })
            } else {
              const token = res.tokenObject.token
              resolve(token)
            }
          }
        )
      })
    },
  },
}
